import axios from 'axios';
import { getAuth, signOut as firebaseSignOut } from 'firebase/auth';
import { SYMFONY_API_BASE_URL } from '@config/apiConfig';
const signOut = async () => {
    const auth = getAuth();
    await firebaseSignOut(auth);
    // Hitting the logout endpoint to ensure PHP session ends
    const serverLogoutUrl = `${SYMFONY_API_BASE_URL}/logout`;
    await axios.get(serverLogoutUrl);
};
export default signOut;
